import * as React from 'react'
import { IconButton } from '../..'
import { ComponentProps } from 'react'
import UsageAndCostDropdownActions from '@/features/Analytics/components/UsageAndCostDropdownActions/UsageAndCostDropdownActions'

type WidgetHeaderProps = React.PropsWithChildren & {
    title: string
    buttonProps?: ComponentProps<typeof IconButton>
}

export const WidgetHeader: React.FC<WidgetHeaderProps> = ({
    title,
    buttonProps,
}) => {
    return (
        <div className="flex items-center justify-between gap-4">
            <h5 className="text-heading-7" data-testid="card-title">
                {title}
            </h5>
            {buttonProps && (
                <UsageAndCostDropdownActions buttonProps={buttonProps} />
            )}
        </div>
    )
}
